import { QSpinner, QText } from '@qualio/ui-components';
import { EventType } from '../../../types';
import ItemWithIdAndNameLabel from './ItemWithIdAndNameLabel';
import { CodeWithNameTooltip } from './ItemWithCodeAndNameLabel';

const ActiveEventTypeFilter = ({
  value,
  eventTypesMap,
  isMultiSelect = false,
  isMultiSelectEventsListEnabled = false,
}: {
  value: unknown;
  eventTypesMap: Record<string, EventType>;
  isMultiSelect?: boolean;
  isMultiSelectEventsListEnabled?: boolean;
}) => {
  const lineageId = value as string;
  const eventType = eventTypesMap[lineageId];
  if (eventType) {
    if (isMultiSelectEventsListEnabled) {
      return <CodeWithNameTooltip code={eventType.prefix} name={eventType.name} />;
    }
    if (isMultiSelect) {
      return (
        <QText as="span">
          {eventType.prefix} - {eventType.name}
        </QText>
      );
    }
    return <ItemWithIdAndNameLabel itemName={eventType.name} itemId={eventType.prefix} setMinWidth={false} />;
  }
  return <QSpinner size="sm" />;
};

export default ActiveEventTypeFilter;
